<template>
  <b-card class="layered box">
    <input-buscar :filter="filter" @input="filter = $event">
      <boton-agregar
        @mostrarModalAgregar="goToAddGeofence"
        :textoBoton="$t('vGeocercas.agregarGeocercas')"
        :iconBoton="'alert-circle'">
      </boton-agregar>
    </input-buscar>
    <div>
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <b-card>
            <b-skeleton animation="throb" width="85%"></b-skeleton>
            <b-skeleton animation="throb" width="55%"></b-skeleton>
            <b-skeleton animation="throb" width="70%"></b-skeleton>
          </b-card>
        </template>
        <base-table
          class="tblgeocercas"
          :items="geofences"
          :fields="translatedFields"
          :filter="filter"
          @filtered="onFiltered"
          :perPage="10"
          :currentPage="currentPage"
          :total-rows="totalRows">
          <template #cell(dispositivos)="data">
            <div v-if="data.item.dispositivos.length">
              <span v-for="(dis, index) in data.item.dispositivos" :key="index">
                {{ dis.nombre }}<span v-if="index !== data.item.dispositivos.length - 1">,</span>
              </span>
            </div>
            <div v-else>{{ $t("vGeocercas.noDispo") }}</div>
          </template>
          <template #cell(grupo)="data">
            <div v-if="data.item.usuario?.area">
              {{ data.item.usuario.area.nombre }}
            </div>
            <div v-else>{{ $t("vGeocercas.noAplica") }}</div>
          </template>
          <template #cell(acciones)="data">
            <div>
              <span
                @click="goToGeofenceEdit(data.item)"
                v-b-tooltip.hover
                :title="$t('Gral.editar')">
                <feather type="edit" class="feather-sm mr-2"></feather>
              </span>
              <span
                @click="removeGeofence(data.item)"
                v-b-tooltip.hover
                :title="$t('Gral.eliminar')">
                <feather type="trash-2" class="feather-sm mr-2"></feather>
              </span>
            </div>
          </template>
        </base-table>
      </b-skeleton-wrapper>
    </div>
  </b-card>
</template>

<script>
import GeocercaDataService from "../../../services/GeocercaDataService";
import AccionesDataService from '../../../services/AccionesDataService';
import Crypto from "../../../services/Crypto";

import { mapState } from "vuex";
import InputBuscar from './../../components/InputBuscar'
import BotonAgregar from '../../components/BotonAgregar.vue'
import BaseTable from './../../components/BaseTable'
import { customizedSweetAlert, generalSweetAlert } from "../../../utils/Utils";

export default {
  components: {
    BaseTable,
    InputBuscar,
    BotonAgregar
  },
  data() {
    return {
      /** Variable encargada de almacenar la key del usuario */
      key: '',
      /** Lista que almacena las geocercas obtenidas */
      geofences: [],
      /** Lista de los campos de la tabla */
      fields: [
        { key: "nombre", label: "nombre", sortable: true, },
        { key: "alerta", label: "alerta", sortable: true, },
        { key: "usuario.matricula", label: "usuario", sortable: true, },
        { key: "dispositivos", label: "dispositivos", },
        { key: "grupo", label: "grupo", },
        { key: "acciones", label: "acciones", },
      ],
      /** Variable encargada de almacenar el total de geocercas (items) obtenidas */
      totalRows: 1,
      /** Variable encargada de alamacenar el indice por defecto de la tabla */
      currentPage: 1,
      /** Variable encargada de almacenar el item a buscar dentro de la tabla */
      filter: null,
      loading: true,
    }
  },
  computed: {
    ...mapState(["locale"]),

    /** Método encargado de traducir las cabeceras de la tabla */
    translatedFields() {
      return this.fields.map((field) => {
        if (typeof field === "object" && field.label) {
          return {
            ...field,
            label: this.$t(`tableHeaders.${field.label}`),
          };
        } else {
          return field;
        }
      });
    },
  },
  mounted(){
    this.key = sessionStorage.getItem('key');
    this.getAllGeofences();
  },
  methods: {
    /** Método encargado de obtener todas las geocercas */
    async getAllGeofences(){
      try{
        const response = await GeocercaDataService.getAll();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.geofences = decoded.map(this.serializeGeofence)
        this.totalRows = this.geofences.length;
        this.loading = false;
      }catch(error){
        console.error(error);
      }
    },

    /** Método encargado de serializar los datos necesarios de la geocerca */
    serializeGeofence(geofence) {
      return {
        alerta: geofence.alerta,
        color: geofence.color,
        dispositivos: geofence.dispositivos,
        id: geofence.id,
        latitud: geofence.latitud,
        locate: geofence.locate,
        longitud: geofence.longitud,
        nombre: geofence.nombre,
        radio: geofence.radio,
        usuario: geofence.usuario,
      };
    },

    /** Método encargado de filtrar el item a buscar dentro de la tabla */
    onFiltered(filteredItem) {
      this.totalRows = filteredItem;
      this.currentPage = 1;
    },

    /** Método encargado de cambiar a la vista edición de la geocerca seleccionada */
    goToGeofenceEdit(geofence) {
      this.$router.push({
        name: "Editar geocerca",
        params: geofence,
      });
    },
    /** Método encargado de cambiar a la vista 'Agregar geocerca' */
    goToAddGeofence(){
      this.$router.push({
        path: "/AddGeocercas",
      });
    },
    /** Método encargado de remover la geocerca seleccionada del sistema */
    async removeGeofence(geofence) {
      try{
        const responseModal = await customizedSweetAlert(this.$t('vGeocercas.eliminarGeo'), 'warning');
        if(responseModal){
          geofence.habilitado = false;
          geofence.dispositivos = [];
          try{
            const response = await GeocercaDataService.update(geofence, this.key);
            if(response.status === 200){
              const action = "Eliminó la geocerca " + geofence.nombre;
              this.logAction(action);
              generalSweetAlert(this.$t('vGeocercas.msgDelGeocerca'), 'success');
              this.getAllGeofences();
            }
          }catch(error){
            console.error('Error al remover geocerca: ', error);
            generalSweetAlert(this.$t('vGeocercas.errDelGeocerca'), 'error');
          }
        }
      }catch(error){
        console.error('Se ha producido un error al obtener la acción del usuario: ', error)
      }
    },

    /** Método encargado de realizar la acción ejercida por el usuario */
    logAction(action) {
      const bodyAction = {
        usuario: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
        accion: action + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(bodyAction, this.key);
    },
  },
}
</script>

<style>
.layered.box {
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
  0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
  0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
}

.box {
    border-radius: 2px;
    background-color: white;
}
/**Configuración para resolución de pantallas móviles */
@media (max-width: 959px) {
  /* Forzar la tabla para cambiar apariencia en dispositivos móviles. */
  .tblgeocercas table,
  .tblgeocercas thead,
  .tblgeocercas tbody,
  .tblgeocercas th,
  .tblgeocercas td,
  .tblgeocercas tr {
    display: block;
  }

  /* Ocultar cabeceras de tabla. */
  .tblgeocercas thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tblgeocercas tr {
    border: 1px solid #ccc;
  }

  .tblgeocercas td {
    /* Se aplica un comportamiento como el de una «fila» */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 5%;
    text-align: left;
  }

  .tblgeocercas td:after {
    /* Ahora como una cabecera de tabla */
    position: relative;
    /* Los valores superior/izquierdo imitan el relleno */
    top: 6px;
    left: 6px;
    width: 70%;
    padding-right: 10px;
    white-space: nowrap;
  }
  /* Etiqueta de los datos */
  .tblgeocercas td:first-child:before {
    content: "Nombre: ";
    font-weight: 400;
  }
  .tblgeocercas td:nth-of-type(2):before {
    content: "Alerta: ";
    font-weight: 400;
  }
  .tblgeocercas td:nth-of-type(3):before {
    content: "Usuarios: ";
    font-weight: 400;
  }
  .tblgeocercas td:nth-of-type(4):before {
    content: "Dispositivos: ";
    font-weight: 400;
  }
  .tblgeocercas td:nth-of-type(5):before {
    content: "Grupo: ";
    font-weight: 400;
  }
  .tblgeocercas td:last-child:before {
    content: "Acciones: ";
    font-weight: 400;
  }
}
</style>